import { useCallback, useLayoutEffect, useState } from 'react';

type UseChartLabelWidthOptions = {
  initialWidth: number;
  disabled?: boolean;
};

/** Measures an SVG label group and updates its reserved width when the labels change. */
export const useChartLabelWidth = ({
  initialWidth,
  disabled = false,
}: UseChartLabelWidthOptions) => {
  const [labelGroup, setLabelGroup] = useState<SVGGElement | null>(null);
  const [labelWidth, setLabelWidth] = useState(initialWidth);

  const labelGroupRef = useCallback((node: SVGGElement | null) => setLabelGroup(node), []);

  useLayoutEffect(() => {
    if (!labelGroup || disabled) return;

    const measureLabelWidth = () => {
      const measuredWidth = Math.ceil(labelGroup.getBBox().width);
      if (!isFinite(measuredWidth) || measuredWidth <= 0) return;
      setLabelWidth((current) => (current === measuredWidth ? current : measuredWidth));
    };

    measureLabelWidth();

    const observer = new ResizeObserver(measureLabelWidth);
    observer.observe(labelGroup);

    return () => observer.disconnect();
  }, [disabled, labelGroup]);

  return { labelGroupRef, labelWidth };
};
